export enum PageStatus {
    PUBLISHED = "published",
    DRAFT = "draft",
}
